import { CommonModule, DatePipe } from '@angular/common';
import { NgModule, Pipe, PipeTransform, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { AuditTrailItem, AuditTrailShiftType } from '@wilson/api/gateway';
import {
  AuditTrailDrawerState,
  AuditTrailShiftState,
} from '@wilson/audit-trail/states';

@Pipe({
  name: 'auditTrailPreviousStartDate',
  standalone: false,
})
export class AuditTrailPreviousStartDatePipe implements PipeTransform {
  private readonly store = inject(Store);
  private readonly datePipe = inject(DatePipe);

  transform(
    currentAuditItem: AuditTrailItem,
    searchedType: AuditTrailShiftType = 'changedDate',
  ): string {
    const currentShiftId: string = this.store.selectSnapshot(
      AuditTrailDrawerState.currentShiftId,
    );
    const lastAuditItem: AuditTrailItem | null = this.store.selectSnapshot(
      AuditTrailShiftState.findAuditItemOfSameType(
        currentShiftId,
        currentAuditItem,
        searchedType,
      ),
    );
    return (
      this.datePipe.transform(
        lastAuditItem?.historyDelta?.startDate,
        'dd.MM.yyyy',
      ) ?? 'n/a'
    );
  }
}

@NgModule({
  imports: [CommonModule],
  declarations: [AuditTrailPreviousStartDatePipe],
  exports: [AuditTrailPreviousStartDatePipe],
})
export class AuditTrailPreviousStartDatePipeModule {}
